const ACCESS_TOKEN_KEY = "milton_access_token";
const REFRESH_TOKEN_KEY = "milton_refresh_token";
const USER_UUID_KEY = "milton_user_uuid";
const ORG_UUID_KEY = "milton_org_uuid";

export const getToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(ACCESS_TOKEN_KEY, token);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const setRefreshToken = (token) => localStorage.setItem(REFRESH_TOKEN_KEY, token);

export const getUserUuid = () => localStorage.getItem(USER_UUID_KEY);
export const setUserUuid = (uuid) => localStorage.setItem(USER_UUID_KEY, uuid);

export const getOrgUuid = () => localStorage.getItem(ORG_UUID_KEY);
export const setOrgUuid = (uuid) => localStorage.setItem(ORG_UUID_KEY, uuid);

export const isAuthenticated = () => !!getToken();

export const setAuthData = (data) => {
  setToken(data.accessToken);
  setRefreshToken(data.refreshToken);
  if (data.userUuid) setUserUuid(data.userUuid);
  if (data.orgUuid) setOrgUuid(data.orgUuid);
};

export const clearAuth = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_UUID_KEY);
  localStorage.removeItem(ORG_UUID_KEY);
};
